module.exports = __webpack_public_path__ + "static/home_low-971e979cadcee78fa2f6362fac90e9f3.mp4";